/*
 * @Date: 2022-06-09 15:06:26
 * @LastEditors: guantingting
 * @LastEditTime: 2023-03-07 16:54:09
 */
export default [
    {
        path: '/rent/v2/travel',
        name: 'travel',
        component: () => import('@/pages/travelProduct/index'),
        meta: { title: '旅游', requireAuth: true },
    },
    {
      path: '/rent/v2/travel-hot-city',
      name: 'travelHotCity',
      component: () => import('@/pages/travelProduct/hotCity'),
      meta: { title: '热门城市', requireAuth: true },
  },
    {
      path: '/rent/v2/travel/travelSearch',
      name: 'travelSearch',
      component: () => import('@/pages/travelProduct/travelSearch'),
      meta: { title: '旅游搜索', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/travelCity',
      name: 'travelCity',
      component: () => import('@/pages/travelProduct/cityList'),
      meta: { title: '目的地', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/orderCancle',
      name: 'orderCancle',
      component: () => import('@/pages/travelProduct/orderCancle'),
      meta: { title: '取消订单', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/productDetail',
      name: 'productDetail',
      component: () => import('@/pages/travelProduct/productDetail'),
      meta: { title: '产品详情', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/productList',
      name: 'travelProductList',
      component: () => import('@/pages/travelProduct/travelProductList'),
      meta: { title: '产品列表', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/travelTime',
      name: 'travelTime',
      component: () => import('@/pages/travelProduct/travelTime'),
      meta: { title: '出发日期', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/renterList',
      name: 'renterList',
      component: () => import('@/pages/travelProduct/renterList'),
      meta: { title: '常用出行人', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/round',
      name: 'round',
      component: () => import('@/pages/travelProduct/round'),
      meta: { title: '周边服务', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/orderCoupon',
      name: 'orderCoupon',
      component: () => import('@/pages/travelProduct/orderCoupon'),
      meta: { title: '选择优惠券', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/orderAround',
      name: 'orderAround',
      component: () => import('@/pages/travelProduct/orderAround'),
      meta: { title: '周边商品', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/policy',
      name: 'policy',
      component: () => import('@/pages/travelProduct/policy'),
      meta: { title: '投保人信息', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/vehicleList',
      name: 'vehicleList',
      component: () => import('@/pages/travelProduct/vehicleList'),
      meta: { title: '选择车型', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/vehicleDetail',
      name: 'travelVehicleDetail',
      component: () => import('@/pages/travelProduct/vehicleDetail'),
      meta: { title: '车型详情', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/coupon',
      name: 'travelCoupon',
      component: () => import('@/pages/travelProduct/travelCoupon'),
      meta: { title: '优惠活动', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/customMade',
      name: 'customMade',
      component: () => import('@/pages/travelProduct/customMade'),
      meta: { title: '定制服务', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/userEvaluate',
      name: 'userEvaluate',
      component: () => import('@/pages/travelProduct/userEvaluate'),
      meta: { title: '用户评价', requireAuth: true },
    },
    {
      path: '/rent/v2/travel/journey',
      name: 'journey',
      component: () => import('@/pages/travelProduct/journey'),
      meta: { title: '行程说明', requireAuth: true },
    },
]


// WEBPACK FOOTER //
// ./src/pages/travelProduct/travel.js